import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useUserContext } from "context/UserContext";
import getGraphQLEndpoint from "utils/getGraphQLEndpoint";
import { useTranslation } from "react-i18next";

function TablesSP() {
  const { t } = useTranslation("common");
  const { idToken, posPidArray } = useUserContext();
  const [metabaseUrl, setMetabaseUrl] = useState("");
  const [error, setError] = useState(null);

  const backendUrl = useMemo(getGraphQLEndpoint, []);
  const androidIDList = useMemo(() => {
    if (!Array.isArray(posPidArray)) return [];
    return posPidArray
      .map((item) => (item?.android_id ? String(item.android_id).trim() : ""))
      .filter(Boolean);
  }, [posPidArray]);

  useEffect(() => {
    const fetchMetabaseUrl = async () => {
      if (!backendUrl) {
        setError("後端 API 位址未設定，請聯絡系統管理員。");
        return;
      }
      if (!idToken) {
        setError("User is not authenticated.");
        return;
      }
      if (!androidIDList.length) {
        setError("無綁定的裝置，無法載入報表。");
        return;
      }

      try {
        const response = await fetch(backendUrl, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${idToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: `
              query GetMetabaseURL($androidID: [String!]!) {
                GetMetabaseEmbedURLwithAndroidIDforTable(androidID: $androidID)
              }
            `,
            variables: { androidID: androidIDList },
          }),
        });

        const payload = await response.json();

        if (!response.ok) {
          const message =
            payload?.errors?.[0]?.message || `Failed to fetch Metabase URL (${response.status})`;
          throw new Error(message);
        }

        const url = payload?.data?.GetMetabaseEmbedURLwithAndroidIDforTable;
        if (!url) {
          throw new Error("Metabase 回傳為空，請稍後再試。");
        }
        setMetabaseUrl(url);
        setError(null);
      } catch (err) {
        console.error(err);
        setError(err.message || "Failed to load Metabase URL");
      }
    };

    fetchMetabaseUrl();
  }, [idToken, androidIDList, backendUrl]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {t("pageTitles.tables")}
                </MDTypography>
              </MDBox>
              <MDBox pt={3} px={0} width="100%">
                {metabaseUrl ? (
                  <iframe
                    src={metabaseUrl}
                    width="100%"
                    height="800px"
                    frameBorder="0"
                    title="Metabase Table"
                  />
                ) : (
                  <MDTypography p={2}>{error || t("states.loadingTransactions")}</MDTypography>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default TablesSP;
